
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"18","viewBox":"0 0 18 18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M1.5 9.115a7.615 7.615 0 113.98 6.693l-2.998.558a.532.532 0 01-.619-.62l.559-2.998A7.579 7.579 0 011.5 9.115zM7.942 6c-.244.207-.421.523-.421.99a.531.531 0 11-1.063 0c0-.773.31-1.387.797-1.8.474-.403 1.089-.591 1.683-.591.593 0 1.207.188 1.682.59.487.414.797 1.028.797 1.8 0 .543-.14.957-.367 1.297-.19.286-.438.507-.633.681l-.061.056c-.219.195-.382.357-.503.569-.114.203-.207.487-.207.94a.531.531 0 01-1.063 0c0-.611.129-1.08.346-1.463.212-.374.49-.634.715-.836l.051-.046c.213-.192.36-.323.471-.49.106-.158.188-.365.188-.707 0-.467-.177-.783-.421-.99-.255-.217-.615-.339-.995-.339s-.74.122-.996.339zm1.574 7.72a.532.532 0 10-.789-.712l-.007.008a.531.531 0 00.79.711l.006-.008z","fill":"#07193D"}})])
          )
        }
      }
    